import { render, staticRenderFns } from "./DecoctingOrd.vue?vue&type=template&id=a384ee32"
import script from "./DecoctingOrd.vue?vue&type=script&lang=js"
export * from "./DecoctingOrd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a384ee32')) {
      api.createRecord('a384ee32', component.options)
    } else {
      api.reload('a384ee32', component.options)
    }
    module.hot.accept("./DecoctingOrd.vue?vue&type=template&id=a384ee32", function () {
      api.rerender('a384ee32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Decocting/DecoctingOrd.vue"
export default component.exports